<template lang='pug'></template>

<script>
function mounted()
{
  this.$emit('event');
}

export default
{
  mounted
};
</script>